/*if(window.location.pathname.includes("/products/")){$(".shopify-section--header").addClass("active")}else if(window.location.pathname.includes("/pages") || window.location.pathname.includes("/cart")){$(".shopify-section--header").addClass("active")}else window.location.pathname.includes("/collections")?$(".shopify-section--header").addClass("active"):$(window).on("scroll",function(){$(window).scrollTop()>50?$(".shopify-section--header").addClass("active"):$(".shopify-section--header").removeClass("active")});$(document).ready(function(){var t=$("#product_description"),e=$(".read-more-btn"),a=$(".read-less-btn");e.on("click",function(){t.css("height","auto").css("-webkit-mask-image","none"),e.hide(),a.show()}),a.on("click",function(){t.css("height","100px").css("-webkit-mask-image","linear-gradient(180deg,#000 50%,#0000)"),e.show(),a.hide()}),$(".drop_down_options").on("click",function(){$(".bundle_variant_picker_hidden").toggle(),$(".dropdown_icon").toggleClass("open")});let n=$("input[name=id]:checked"),i=$("#product-image"),c=$("#product-price"),o=$("#variant-title");n.each(function(){let t=$(this),e=t.data("image"),a=t.data("image-alt"),n=t.data("price"),s=t.data("name");i.attr("src",e),i.attr("alt",a),c.text(n),o.text(s)}),$("input[name=id]").on("change",function(){let t=$(this),e=t.data("image"),a=t.data("image-alt"),n=t.data("price"),s=t.data("name");i.attr("src",e),i.attr("alt",a),c.text(n),o.text(s),$(".bundle_variant_picker_hidden").css("display","none"),$(".dropdown_icon").toggleClass("open")}),$("#bundle-form").on("submit",function(t){t.preventDefault(),$(this).data("bundle-product-id"),$(this).data("bundle-product-handle");var e,a,n=$(this).find('input[name="id"]:checked').val(),i=(e=window.location.href,a=e.indexOf("?variant="),(a>-1?e.substring(a+9):null)||$('input[name="current_id"]').val());$.ajax({type:"POST",url:"/cart/add.js",data:JSON.stringify({items:[{id:i,quantity:1},{id:n,quantity:1}]}),dataType:"json",contentType:"application/json",success:function(){document.documentElement.dispatchEvent(new CustomEvent("cart:refresh",{bubbles:!0})),$.getJSON("/cart.js",function(t){$(".count-bubble").text(t.item_count),$(".count-bubble").css("opacity",1)});let t=document.querySelector("#cart-drawer");t.show()},error:function(){alert("Error: Unable to add product(s) to cart!")}})})});*/

document.addEventListener("DOMContentLoaded", function () {
  const header = document.querySelector(".shopify-section--header");
  const pathname = window.location.pathname;

  if (
    pathname.includes("/products/") ||
    pathname.includes("/pages") ||
    pathname.includes("/cart")
  ) {
    header.classList.add("active");
  } else if (pathname.includes("/collections")) {
    header.classList.add("active");
  } else {
    window.addEventListener("scroll", function () {
      if (window.scrollY > 50) {
        header.classList.add("active");
      } else {
        header.classList.remove("active");
      }
    });
  }

  const productDescription = document.getElementById("product_description");
  const readMoreBtn = document.querySelector(".read-more-btn");
  const readLessBtn = document.querySelector(".read-less-btn");

  if (readMoreBtn && readLessBtn && productDescription) {
    readMoreBtn.addEventListener("click", function () {
      productDescription.style.height = "auto";
      productDescription.style.webkitMaskImage = "none";
      readMoreBtn.style.display = "none";
      readLessBtn.style.display = "inline-block";
    });

    readLessBtn.addEventListener("click", function () {
      productDescription.style.height = "100px";
      productDescription.style.webkitMaskImage = "linear-gradient(180deg,#000 50%,#0000)";
      readMoreBtn.style.display = "inline-block";
      readLessBtn.style.display = "none";
    });
  }

  const dropDown = document.querySelector(".drop_down_options");
  const variantPickerHidden = document.querySelector(".bundle_variant_picker_hidden");
  const dropdownIcon = document.querySelector(".dropdown_icon");

  if (dropDown && variantPickerHidden && dropdownIcon) {
    dropDown.addEventListener("click", function () {
      variantPickerHidden.style.display = variantPickerHidden.style.display === "none" ? "block" : "none";
      dropdownIcon.classList.toggle("open");
    });
  }

  const variantInputs = document.querySelectorAll('input[name="id"]');
  const selectedVariant = document.querySelector('input[name="id"]:checked');
  const productImage = document.getElementById("product-image");
  const productPrice = document.getElementById("product-price");
  const variantTitle = document.getElementById("variant-title");

  if (selectedVariant && productImage && productPrice && variantTitle) {
    const image = selectedVariant.dataset.image;
    const alt = selectedVariant.dataset.imageAlt;
    const price = selectedVariant.dataset.price;
    const name = selectedVariant.dataset.name;
    productImage.src = image;
    productImage.alt = alt;
    productPrice.textContent = price;
    variantTitle.textContent = name;
  }

  variantInputs.forEach(function (input) {
    input.addEventListener("change", function () {
      const image = input.dataset.image;
      const alt = input.dataset.imageAlt;
      const price = input.dataset.price;
      const name = input.dataset.name;

      if (productImage) productImage.src = image;
      if (productImage) productImage.alt = alt;
      if (productPrice) productPrice.textContent = price;
      if (variantTitle) variantTitle.textContent = name;

      if (variantPickerHidden) variantPickerHidden.style.display = "none";
      if (dropdownIcon) dropdownIcon.classList.toggle("open");
    });
  });
/*
  const bundleForm = document.getElementById("bundle-form");
  if (bundleForm) {
    bundleForm.addEventListener("submit", function (e) {
      e.preventDefault();

      const selected = bundleForm.querySelector('input[name="id"]:checked');
      if (!selected) return;

      const variantId = selected.value;
      const currentUrl = window.location.href;
      const variantParamIndex = currentUrl.indexOf("?variant=");
      const currentId =
        variantParamIndex > -1
          ? currentUrl.substring(variantParamIndex + 9)
          : document.querySelector('input[name="current_id"]')?.value;

      if (!variantId || !currentId) return;

      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          items: [
            { id: currentId, quantity: 1 },
            { id: variantId, quantity: 1 },
          ],
        }),
      })
        .then((res) => res.json())
        .then(() => {
          document.documentElement.dispatchEvent(
            new CustomEvent("cart:refresh", { bubbles: true })
          );
          fetch("/cart.js")
            .then((res) => res.json())
            .then((cart) => {
              const countBubble = document.querySelector(".count-bubble");
              if (countBubble) {
                countBubble.textContent = cart.item_count;
                countBubble.style.opacity = 1;
              }
            });

          const cartDrawer = document.querySelector("#cart-drawer");
          if (cartDrawer?.show) cartDrawer.show();
        })
        .catch(() => {
          alert("Error: Unable to add product(s) to cart!");
        });
    });
  }
  */
});
